import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { EdButtonComponent } from "@edenred/components/button";
import { ApiService } from "../../../services";
import { usersEndpointConfig } from "../../../configs";
import { finalize } from "rxjs";
import { UserStore } from "../../../stores";
import { TranslocoPipe } from "@jsverse/transloco";
import { NOTIFICATIONS_RULE_CODE } from "../../../enums/notifications.enum";
import { notificationsEndpointConfig } from "../../../configs/endpoints/notifications.endpoint.config";

@Component({
  selector: "app-first-login-modal",
  templateUrl: "./marketing.component.html",
  standalone: true,
  imports: [MatDialogModule, EdButtonComponent, TranslocoPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirstLoginModalComponent {
  isLoading = false;

  constructor(
    private dialogRef: MatDialogRef<FirstLoginModalComponent>,
    private readonly apiService: ApiService,
  ) {}

  private readonly userStore = inject(UserStore);

  public confirm(): void {
    const { user_id } = this.userStore.user();
    this.apiService
      .post(null, usersEndpointConfig.marketingConsent(user_id ?? "", true))
      .pipe(
        finalize((): void => {
          this.userStore
            .loadUserProfile()
            .pipe(
              finalize((): void => {
                this.updateUserPreferences();
              }),
            )
            .subscribe();
        }),
      )
      .subscribe();
  }

  public deny(): void {
    const { user_id } = this.userStore.user();
    this.apiService
      .post(null, usersEndpointConfig.marketingConsent(user_id ?? "", false))
      .pipe(
        finalize((): void => {
          this.isLoading = false;
          this.dialogRef.close();
        }),
      )
      .subscribe();
  }

  private updateUserPreferences() {
    this.apiService
      .post(
        {
          rule_code:
            NOTIFICATIONS_RULE_CODE.MARKETING_COMMUNICATIONS_NOTIFICATION_RULE,
          is_email_enabled: true,
        },
        notificationsEndpointConfig.userPreferences(),
      )
      .pipe(
        finalize((): void => {
          this.isLoading = false;
          this.dialogRef.close();
        }),
      )
      .subscribe();
  }
}
